{
  "groups": {
    "referenceNumber": "Số tham chiếu",
    "appointmentStartTimes": "Giờ bắt đầu cuộc hẹn",
    "appointmentNotifications": "Thông báo cuộc hẹn",
    "appointmentStatuses": "Trạng thái cuộc hẹn",
    "customAppointmentsGrid": "Lưới cuộc hẹn tùy chỉnh",
    "limiter": "Bộ giới hạn",
    "schedulingPortal": "Cổng đặt lịch",
    "dockSelection": "Chọn cửa kho",
    "timeDisplay": "Hiển thị thời gian",
    "gateManagement": "Quản lý cổng",
    "smartGate": "SmartGate",
    "idValidation": "Xác minh danh tính",
    "appointmentValidation": "Xác thực cuộc hẹn",
    "other": "Khác",
    "handlingUnits": "Đơn vị hàng hóa"
  },
  "groupDescriptions": {
    "referenceNumberIsTheReferenceYouCanRequestFromCarriersWhenTheyreSchedulingAnAppointment": "Số tham chiếu là thông tin tham chiếu bạn có thể yêu cầu từ hãng vận chuyển khi họ đặt lịch hẹn.",
    "determineTheTimeIntervalsAtWhichAppointmentsWillBeAllowedToStart": "Xác định các khoảng thời gian mà cuộc hẹn được phép bắt đầu.",
    "manageAllTypesOfAppointmentNotificationsForThisEntity": "Quản lý tất cả các loại thông báo cuộc hẹn cho {entity} này.",
    "manageTheSchedulingPortalSettingsForThisEntity": "Quản lý cài đặt Cổng đặt lịch cho {entity} này",
    "handlingUnitsIsANumericFieldForRequestingUnitsEGPalletsDuringAppointmentSchedulingAddItToYourFormToAlsoEnableTheLimiterFeature": "Đơn vị hàng hóa là trường số dùng để yêu cầu số đơn vị (ví dụ: pallet) khi đặt lịch hẹn. Thêm trường này vào biểu mẫu để bật cả tính năng Bộ giới hạn.",
    "theLimiterAllowsYouToSetAMaximumNumberOfAppointmentsOrHandlingUnitsEGPalletsThatCanBeScheduledPerDay": "Bộ giới hạn cho phép bạn đặt số lượng tối đa cuộc hẹn hoặc đơn vị hàng hóa (ví dụ: pallet) có thể được đặt lịch mỗi ngày."
  },
  "labels": {
    "minimumAmountOfReferenceNumbers": "Số lượng tối thiểu số tham chiếu",
    "maximumAmountOfReferenceNumbers": "Số lượng tối đa số tham chiếu",
    "includeReferenceNumberFieldOnAllAppointmentForms": "Thêm trường Số tham chiếu vào tất cả biểu mẫu cuộc hẹn?",
    "referenceNumberFieldName": "Tên trường Số tham chiếu",
    "referenceNumberHelperText": "Văn bản hướng dẫn cho Số tham chiếu",
    "makeReferenceNumberARequiredField": "Đặt Số tham chiếu là trường bắt buộc?",
    "allowAppointmentsForThisEntityToStartAt": "Cho phép cuộc hẹn của {entity} này bắt đầu vào:",
    "enableAppointmentNotificationsForThisEntity": "Bật thông báo cuộc hẹn cho {entity} này?",
    "selectEachDesiredStartTimeIndividually": "Chọn riêng từng giờ bắt đầu mong muốn",
    "hideTheLoadTypeDuration": "Ẩn thời lượng của loại hàng?",
    "uploadYourEntityLogoToDisplayItInTheSchedulingPortalAndInAllEmailNotifications": "Tải lên logo {entity} của bạn để hiển thị trên Cổng đặt lịch và trong tất cả thông báo email",
    "uploadYourWarehouseYardMapToDisplayItInTheSchedulingPortal": "Tải lên sơ đồ bãi của kho hàng để hiển thị trên Cổng đặt lịch",
    "statusForNewlyCreatedAppointments": "Trạng thái cho cuộc hẹn mới tạo",
    "muteAppointmentNotifications": "Tắt tiếng thông báo cuộc hẹn",
    "allowDockSelectionInSchedulingPortal": "Cho phép chọn cửa kho trên Cổng đặt lịch?",
    "theStatusThatFollowsArrivedIs": "Trạng thái tiếp theo sau 'Đã đến' là",
    "displayTimeIn": "Hiển thị thời gian theo:",
    "customizeAppointmentDetails": "Tùy chỉnh chi tiết cuộc hẹn",
    "gridTileConfig": "Cấu hình ô lưới",
    "enforceCheckInGeofencingToRequireDriversToProvideTheirRealTimeLocation": "Áp dụng hàng rào địa lý để yêu cầu tài xế cung cấp vị trí theo thời gian thực",
    "wouldYouLikeToShowAdditionalInformationToTheDriversAfterTheyCheckInOptional": "Bạn có muốn hiển thị thông tin bổ sung cho tài xế sau khi họ check-in không? (không bắt buộc)",
    "preventReschedulingAppointmentsInTheSchedulingPortal": "Ngăn đổi lịch cuộc hẹn trên Cổng đặt lịch?",
    "revertToRequestedOnCarrierReschedule": "Chuyển về Đã yêu cầu khi hãng vận chuyển đổi lịch",
    "observationMatchAttribute": "Thuộc tính đối chiếu quan sát",
    "observationMatchTimeWindow": "Khung thời gian đối chiếu quan sát",
    "autoDepartAssets": "Tự động ghi nhận tài sản rời đi",
    "autoCreateAssets": "Tự động tạo tài sản",
    "gateFeedColumns": "Cột Gate Feed",
    "checkInEarlyThreshold": "Ngưỡng check-in sớm",
    "checkInLateThreshold": "Ngưỡng check-in trễ",
    "technicalContactEmailAddress": "Địa chỉ email liên hệ kỹ thuật",
    "technicalContactEmailThrottleMinutes": "Số phút giãn cách email liên hệ kỹ thuật",
    "requireUniqueReferenceNumbers": "Yêu cầu số tham chiếu không trùng lặp",
    "appointmentStartTimeInterval": "Khoảng thời gian bắt đầu cuộc hẹn",
    "referenceNumberInputMode": "Chế độ nhập Số tham chiếu",
    "uploadWarehouseYardMap": "Tải lên sơ đồ bãi của kho hàng để hiển thị trên Cổng đặt lịch",
    "includeHandlingUnitsFieldOnAllAppointmentForms": "Thêm trường Đơn vị hàng hóa vào tất cả biểu mẫu cuộc hẹn?",
    "handlingUnitsLabel": "Nhãn Đơn vị hàng hóa",
    "handlingUnitsHelperText": "Văn bản hướng dẫn cho Đơn vị hàng hóa",
    "makeHandlingUnitsARequiredField": "Đặt Đơn vị hàng hóa là trường bắt buộc?",
    "maximumHandlingUnitsValueForAnAppointment": "Giá trị Đơn vị hàng hóa tối đa cho một cuộc hẹn",
    "minimumHandlingUnitsValueForAnAppointment": "Giá trị Đơn vị hàng hóa tối thiểu cho một cuộc hẹn",
    "checkOutBolSignedRequired": "Bắt buộc ký BOL khi check-out",
    "checkOutBolNotLoadingErrorMessage": "Thông báo lỗi khi không tải được BOL lúc check-out",
    "checkOutIdentifier": "Mã nhận diện khi check-out",
    "enableCheckInIdValidationPersona": "Bật xác minh danh tính khi check-in (Persona)",
    "requireCheckInIdValidationToCompleteCheckIn": "Yêu cầu xác minh danh tính để hoàn tất check-in",
    "checkInIdValidationTemplate": "Mẫu xác minh danh tính khi check-in",
    "geofenceRadius": "Bán kính hàng rào địa lý",
    "createAppointmentOnExternalValidationFailure": "Tạo cuộc hẹn khi xác thực bên ngoài thất bại",
    "enableOverrideLimiterFunction": "Bật chức năng vượt Bộ giới hạn",
    "receiveUnplannedCheckInEmailNotifications": "Nhận thông báo email về check-in không có kế hoạch",
    "driversMustEnterAReferenceNumberToCheckIn": "Tài xế phải nhập số tham chiếu để check-in",
    "driversCanOnlyCheckInIfTheReferenceNumberMatchesTheScheduledAppointment": "Tài xế chỉ có thể check-in nếu số tham chiếu khớp với cuộc hẹn đã lên lịch",
    "driversSkipTheReferenceNumberStepDuringCheckIn": "Tài xế bỏ qua bước nhập số tham chiếu khi check-in",
    "customizeTheFirstSmsMessageDriversReceiveAfterCheckInOptional": "Tùy chỉnh tin nhắn SMS đầu tiên tài xế nhận được sau khi check-in (không bắt buộc)",
    "includeYardMapImageInTheFirstCheckInSms": "Đính kèm hình ảnh sơ đồ bãi trong SMS check-in đầu tiên?",
    "automaticallyDeleteStoredIdValidations": "Tự động xóa dữ liệu xác minh danh tính đã lưu",
    "deleteStoredIdValidationsAfter": "Xóa dữ liệu xác minh danh tính đã lưu sau",
    "displayDatesAs": "Hiển thị ngày dạng:",
    "displayTimeAs": "Hiển thị giờ dạng:"
  },
  "descriptions": {
    "requireAtLeastThisAmountOfReferenceNumbersForAnAppointment": "Yêu cầu ít nhất số lượng số tham chiếu này cho một cuộc hẹn",
    "requireAtMostThisAmountOfReferenceNumbersForAnAppointment": "Yêu cầu tối đa số lượng số tham chiếu này cho một cuộc hẹn",
    "theDisplayNameForTheReferenceNumberFieldEgPoNumberShipmentId": "Tên hiển thị cho trường Số tham chiếu. Ví dụ: \"Số PO\", \"ID lô hàng\"",
    "additionalInformationToHelpFillInTheReferenceNumberFieldEgReferenceNumberShouldStartWithOdXx": "Thông tin bổ sung giúp điền trường Số tham chiếu. Ví dụ: \"Số tham chiếu phải bắt đầu bằng OD-XX\"",
    "requireTheReferenceNumberForAllAppointmentsBeingScheduled": "Yêu cầu Số tham chiếu cho tất cả cuộc hẹn được đặt lịch",
    "thisOnlyAffectsNewlyCreatedAppointments": "Điều này chỉ ảnh hưởng đến cuộc hẹn mới tạo",
    "theDurationIsDisplayedOnTheLoadTypesSelectListBookingAnAppointmentInTheSchedulingPortal": "Thời lượng được hiển thị trong danh sách chọn Loại hàng khi đặt lịch hẹn trên Cổng đặt lịch",
    "allowDockSelectionWhenBookingAnAppointmentInTheSchedulingPortal": "Cho phép chọn cửa kho khi đặt lịch hẹn trên Cổng đặt lịch",
    "thisSettingWillAllowTheChoiceOfAnAlternateInProgressStatusBetweenArrivedAndCompleted": "Cài đặt này cho phép chọn trạng thái thay thế 'Đang xử lý' giữa 'Đã đến' và 'Đã hoàn tất'",
    "determineHowTimeWillBeDisplayedAcrossThePlatformForAllUsersOfThisOrgIncludingTheAppointmentsGridAndReports": "Xác định cách hiển thị thời gian trên toàn nền tảng cho tất cả người dùng của Tổ chức này, bao gồm lưới cuộc hẹn và báo cáo.",
    "enableToSwitchToTheNewCustomizableAppointmentDetailsSystem": "Bật để chuyển sang hệ thống chi tiết cuộc hẹn tùy chỉnh mới",
    "userConfigurationOfHowGridTilesWillBeDisplayed": "Cấu hình của người dùng về cách hiển thị các ô lưới.",
    "thisSettingAsksForTheDriversLocationAndRestrictsThemFromCheckingInWhenTheyAreMoreThanOneMileAwayFromYourWarehouse": "Cài đặt này yêu cầu vị trí của tài xế và không cho phép họ check-in khi ở cách kho hàng của bạn hơn một dặm.",
    "preventCarriersFromReschedulingAppointmentsOptional": "Ngăn hãng vận chuyển đổi lịch cuộc hẹn. (không bắt buộc)",
    "whenACarrierReschedulesAScheduledAppointmentMoveItBackToRequestedForReApproval": "Khi hãng vận chuyển đổi lịch một cuộc hẹn Đã lên lịch, chuyển cuộc hẹn về Đã yêu cầu để phê duyệt lại",
    "attributeToBeUsedForMatchingObservations": "Thuộc tính được dùng để đối chiếu các quan sát",
    "theNumberOfMinutesToAccountForAnObservationBeforeAndAfterTheCheckInTime": "Số phút tính cho một quan sát trước và sau thời điểm check-in",
    "theNumberOfMinutesBeforeTheAppointmentStartTimeThatACarrierCanCheckIn": "Số phút trước giờ bắt đầu cuộc hẹn mà hãng vận chuyển có thể check-in",
    "theNumberOfMinutesAfterTheAppointmentStartTimeThatACarrierCanCheckIn": "Số phút sau giờ bắt đầu cuộc hẹn mà hãng vận chuyển có thể check-in",
    "emailAddressWhereTechnicalIssuesAndInformationWillBeSent": "Địa chỉ email nhận các sự cố và thông tin kỹ thuật",
    "theTimeBetweenNotificationsSentToTheTechnicalContactWhenAValidationServerErrorOccurs": "Khoảng thời gian giữa các thông báo gửi đến liên hệ kỹ thuật khi xảy ra lỗi máy chủ xác thực.",
    "aListOfMutedAppointmentNotifications": "Danh sách thông báo cuộc hẹn đã tắt tiếng.",
    "requireUniqueReferenceNumbersForAllAppointmentsBeingScheduled": "Yêu cầu Số tham chiếu không trùng lặp cho tất cả cuộc hẹn được đặt lịch",
    "thisIsTheIntervalMinutesBetweenWhenAppointmentsCanStart": "Đây là khoảng cách (phút) giữa các thời điểm cuộc hẹn có thể bắt đầu",
    "enableTheCustomAppointmentStartTimesSetting": "Bật cài đặt giờ bắt đầu cuộc hẹn tùy chỉnh",
    "theInputModeForTheReferenceNumberField": "Chế độ nhập cho trường số tham chiếu",
    "theDisplayNameForTheUnitTypeFieldEgPalletCountSkidCount": "Tên hiển thị cho trường loại đơn vị. Ví dụ: Số pallet, Số kiện",
    "requireTheUnitTypeFieldForAllAppointmentsBeingScheduled": "Yêu cầu trường loại đơn vị cho tất cả cuộc hẹn được đặt lịch",
    "autoDepartAssetsOnReceivingOutgateEvent": "Tự động ghi nhận tài sản rời đi khi nhận sự kiện ra cổng",
    "autoCreateAssetsOnReceivingIngateEvent": "Tự động tạo tài sản khi nhận sự kiện vào cổng",
    "columnsAvailableOnTheAiGateFeedPageRequiredColumnsAreAlwaysShown": "Các cột có sẵn trên trang AI Gate Feed. Các cột bắt buộc luôn được hiển thị.",
    "createAppointmentsEvenIfAppointmentValidationDoesNotPass": "Tạo cuộc hẹn ngay cả khi không vượt qua xác thực cuộc hẹn",
    "theRadiusInMilesThatTheDriverMustBeWithinToCheckInThisIsOnlyApplicableIfGeofencingIsEnabled": "Bán kính (dặm) mà tài xế phải ở trong phạm vi để check-in. Chỉ áp dụng nếu bật hàng rào địa lý.",
    "additionalInformationToHelpFillInTheUnitTypeFieldEgUnitTypeShouldBeOnlyNumbers": "Thông tin bổ sung giúp điền trường loại đơn vị. Ví dụ: Loại đơn vị chỉ được chứa số",
    "setsTheMaximumNumericValueThatCanBeEnteredForTheHandlingUnitsFieldOnAnAppointment": "Đặt giá trị số tối đa có thể nhập cho trường Đơn vị hàng hóa của một cuộc hẹn",
    "setsTheMinimumNumericValueThatCanBeEnteredForTheHandlingUnitsFieldOnAnAppointment": "Đặt giá trị số tối thiểu có thể nhập cho trường Đơn vị hàng hóa của một cuộc hẹn",
    "whenTheLimiterIs100ReachedThisFeatureAllowsOnlyWarehouseUsersToOverrideAndCreateOrApproveAppointmentsAndUnits": "Khi Bộ giới hạn đạt 100%, tính năng này chỉ cho phép người dùng kho hàng vượt giới hạn để tạo hoặc phê duyệt cuộc hẹn và đơn vị",
    "theAssetAttributeTheSystemWillUseToValidateTheCheckOutForm": "Thuộc tính tài sản mà hệ thống sẽ dùng để xác thực biểu mẫu check-out",
    "enforceBolSigningOnCheckOutForm": "Bắt buộc ký BOL trên biểu mẫu check-out",
    "errorMessageShownToDriversWhenTheBolFailsToLoadDuringCheckOut": "Nếu BOL không có sẵn, hãng vận chuyển sẽ không thể ký, do đó việc check-out sẽ bị chặn. Tại đây, bạn có thể đặt hướng dẫn tùy chỉnh mà tài xế sẽ thấy trong trường hợp này.",
    "showThePersonaComponentInTheCheckInFlowForIdentityVerification": "Hiển thị thành phần Persona trong quy trình check-in để xác minh danh tính",
    "requireSuccessfulPersonaValidationBeforeTheDriverCanCompleteCheckIn": "Yêu cầu xác minh Persona thành công trước khi tài xế có thể hoàn tất check-in",
    "personaTemplateUsedForCheckInIdentityVerification": "Mẫu Persona dùng để xác minh danh tính khi check-in",
    "warehouseSubscribersReceiveEmailNotificationsWhenAnUnplannedCheckInOccurs": "Người nhận của kho hàng sẽ nhận thông báo email khi có check-in không có kế hoạch",
    "thisMessageReplacesTheDefaultCheckInConfirmationTextSentToTheDriverBySmsLeaveBlankToUseTheDefaultMessage": "Tin nhắn này thay thế nội dung xác nhận check-in mặc định gửi cho tài xế qua SMS. Để trống để dùng tin nhắn mặc định.",
    "sendsYourYardMapAsASeparateImageMessageRightAfterTheCheckInSmsRequiresAYardMapToBeUploadedForThisWarehouse": "Gửi sơ đồ bãi của bạn dưới dạng tin nhắn hình ảnh riêng ngay sau SMS check-in. Yêu cầu đã tải lên sơ đồ bãi cho kho hàng này.",
    "storedIdValidationRecordsArePermanentlyDeletedOnceTheRetentionPeriodHasPassed": "Dữ liệu xác minh danh tính đã lưu sẽ bị xóa vĩnh viễn khi hết thời gian lưu giữ",
    "numberOfDaysAStoredIdValidationIsKeptBeforeItIsDeleted": "Số ngày lưu giữ dữ liệu xác minh danh tính trước khi bị xóa",
    "determineHowDatesWillBeDisplayedForUsersOfThisCompanyAcrossCompanyFacingExperiences": "Xác định cách hiển thị ngày cho người dùng của công ty này trên các trải nghiệm dành cho công ty.",
    "determineHowTimeWillBeDisplayedForUsersOfThisCompanyAcrossCompanyFacingExperiences": "Xác định cách hiển thị giờ cho người dùng của công ty này trên các trải nghiệm dành cho công ty."
  },
  "placeholders": {
    "referenceNumberAssociatedWithAppointment": "Số tham chiếu gắn với cuộc hẹn",
    "insertMessageHere": "Nhập tin nhắn tại đây"
  },
  "dropdownOptions": {
    "allowAppointmentsForThisEntityToStartAt": {
      "topOfTheHour00": "Đầu mỗi giờ (:00)",
      "topAndBottomOfTheHour00And30": "Đầu và giữa mỗi giờ (:00 và :30)",
      "everyTwentyMinutes0020And40": "Mỗi hai mươi phút (:00, :20 và :40)",
      "everyQuarterOfTheHour001530And45": "Mỗi mười lăm phút (:00, :15, :30 và :45)",
      "customStartTimes": "Giờ bắt đầu tùy chỉnh"
    },
    "appointmentStartTimeInterval": {
      "15Minutes": "15 phút",
      "30Minutes": "30 phút",
      "60Minutes": "60 phút",
      "90Minutes": "90 phút"
    },
    "observationMatchAttribute": {
      "licensePlate": "Biển số xe",
      "dotNumber": "Số DOT",
      "any": "Bất kỳ",
      "cascade": "Theo thứ tự ưu tiên"
    },
    "referenceNumberInputMode": {
      "alphanumeric": "Chữ và số",
      "numeric": "Chỉ số"
    },
    "statusForNewlyCreatedAppointments": {
      "scheduled": "Đã lên lịch",
      "requested": "Đã yêu cầu"
    },
    "theStatusThatFollowsArrivedIs": {
      "inProgress": "Đang xử lý",
      "completed": "Đã hoàn tất"
    },
    "includeReferenceNumberFieldOnAllAppointmentForms": {
      "noDontIncludeTheReferenceNumberField": "Không, không thêm trường Số tham chiếu",
      "yesIncludeTheReferenceNumberField": "Có, thêm trường Số tham chiếu"
    },
    "hideTheLoadTypeDuration": {
      "noDontHideTheLoadTypeDuration": "Không, không ẩn thời lượng Loại hàng",
      "yesHideTheLoadTypeDuration": "Có, ẩn thời lượng Loại hàng"
    },
    "enableAppointmentNotificationsForThisEntity": {
      "noDisableAppointmentNotifications": "Không, tắt thông báo cuộc hẹn",
      "yesEnableAppointmentNotifications": "Có, bật thông báo cuộc hẹn"
    },
    "allowDockSelectionInSchedulingPortal": {
      "noDontAllowDockSelection": "Không, không cho phép chọn cửa kho",
      "yesAllowTheDockSelection": "Có, cho phép chọn cửa kho"
    },
    "displayTimeIn": {
      "regularTime12Hour": "Giờ thông thường (12 giờ)",
      "militaryTime24Hour": "Giờ quân đội (24 giờ)"
    },
    "preventReschedulingAppointmentsInTheSchedulingPortal": {
      "allowReschedulingInTheSchedulingPortal": "Cho phép đổi lịch trên Cổng đặt lịch ",
      "preventReschedulingInTheSchedulingPortal": "Ngăn đổi lịch trên Cổng đặt lịch"
    },
    "revertToRequestedOnCarrierReschedule": {
      "revertToRequestedOnCarrierReschedule": "Chuyển về Đã yêu cầu khi hãng vận chuyển đổi lịch",
      "keepStatusUnchangedOnCarrierReschedule": "Giữ nguyên trạng thái khi hãng vận chuyển đổi lịch"
    },
    "makeReferenceNumberARequiredField": {
      "noDontMakeReferenceNumberARequiredField": "Không, không đặt Số tham chiếu là trường bắt buộc",
      "yesMakeReferenceNumberARequiredField": "Có, đặt Số tham chiếu là trường bắt buộc"
    },
    "requireUniqueReferenceNumbers": {
      "noDontRequireUniqueReferenceNumbers": "Không, không yêu cầu Số tham chiếu không trùng lặp",
      "yesRequireUniqueReferenceNumbers": "Có, yêu cầu Số tham chiếu không trùng lặp"
    },
    "makeHandlingUnitsARequiredField": {
      "noDontMakeHandlingUnitsARequiredField": "Không, không đặt Đơn vị hàng hóa là trường bắt buộc",
      "yesMakeHandlingUnitsARequiredField": "Có, đặt Đơn vị hàng hóa là trường bắt buộc"
    },
    "includeHandlingUnitsFieldOnAllAppointmentForms": {
      "noDontIncludeTheHandlingUnitsField": "Không, không thêm trường Đơn vị hàng hóa",
      "yesIncludeTheHandlingUnitsField": "Có, thêm trường Đơn vị hàng hóa"
    },
    "checkOutIdentifier": {
      "licensePlate": "Biển số xe",
      "phoneNumber": "Số điện thoại",
      "any": "Bất kỳ"
    },
    "enableCheckInIdValidationPersona": {
      "no": "Không",
      "yes": "Có"
    },
    "requireCheckInIdValidationToCompleteCheckIn": {
      "no": "Không",
      "yes": "Có"
    },
    "checkInIdValidationTemplate": {
      "driverLicenseFront1Retry": "Giấy phép lái xe - Mặt trước - 1 lần thử lại",
      "driverLicenseFrontBarcodeFaceUsOnly1Retry": "Giấy phép lái xe - Mặt trước, mã vạch, khuôn mặt, chỉ Hoa Kỳ, 1 lần thử lại"
    },
    "receiveUnplannedCheckInEmailNotifications": {
      "no": "Không",
      "yes": "Có"
    },
    "displayDatesAs": {
      "mmDdYyyy": "MM/DD/YYYY",
      "ddMmYyyy": "DD/MM/YYYY",
      "yyyyMmDd": "YYYY-MM-DD",
      "tueMmDdYyyy": "T3, MM/DD/YYYY",
      "tueDdMmYyyy": "T3, DD/MM/YYYY",
      "tueYyyyMmDd": "T3, YYYY-MM-DD"
    },
    "displayTimeAs": {
      "12HourEG700Am": "12 giờ (ví dụ: 7:00 AM)",
      "24HourEG0700": "24 giờ (ví dụ: 07:00)"
    }
  },
  "examples": {
    "displayTimeIn": {
      "eG700Am700Pm": "Ví dụ: 7:00 AM / 7:00 PM",
      "eG07001900": "Ví dụ: 07:00 / 19:00"
    }
  },
  "notes": {
    "notesPrefix": "Lưu ý:",
    "ifLeftEmptyTheDefaultNameWillBeApplied": "Nếu để trống, tên mặc định sẽ được áp dụng",
    "ifLeftEmptyTheDefaultHelperTextWillBeApplied": "Nếu để trống, văn bản hướng dẫn mặc định sẽ được áp dụng",
    "enablingThisOptionDoesNotImpactNotificationsThatAreAlreadyDisabledOnTheAppointmentLevelIndividually": "Việc bật tùy chọn này không ảnh hưởng đến các thông báo đã bị tắt riêng lẻ ở cấp cuộc hẹn.",
    "ifLeftEmptyNoNotificationsWillBeSent": "Nếu để trống, sẽ không có thông báo nào được gửi",
    "referenceNumbersAssignedToCancelledOrNoShowAppointmentsMayBeReusedOnNewAppointments": "Số tham chiếu đã gán cho cuộc hẹn bị hủy hoặc vắng mặt có thể được dùng lại cho cuộc hẹn mới",
    "ifEmptyTheDefaultNameWillBeApplied": "Nếu để trống, tên mặc định sẽ được áp dụng"
  },
  "links": {},
  "sectionLabels": {
    "drivers": "Tài xế",
    "checkInSms": "SMS check-in",
    "dataRetention": "Lưu giữ dữ liệu"
  }
}
